import _isEmpty from "lodash/isEmpty";
import querystring from 'querystring';
import { createAction } from 'redux-actions';
import axios from 'axios';
import Cookies from 'universal-cookie';
import isBrowser from '../../utils/isBrowser';
import { API_TIMEOUT, handleApiResponse } from '../../utils/api';
import snakeCaseKeys from '../../utils/snakeCase';
import { getBaseDomain } from '../../utils/domainName';
export var AUTH_COOKIE_NAME = 'blocket-authentication';
var prefix = 'Auth:';
export var SET_API_KEY = "".concat(prefix, " Set values for the api key.");
export var SET_SPID_KEY = "".concat(prefix, " Set values for the spid login.");
export var SET_BEARER_TOKEN = "".concat(prefix, " Set the bearer token for a auth source.");
export var SET_LOGGED_IN = "".concat(prefix, " Set if the user is logged in or not.");
export var LOGOUT = "".concat(prefix, " logout from spid.");
export var HAS_LOGIN_ERROR = "".concat(prefix, " Set if the user has some kind of a loginError");
export var SHOW_LOGIN_TO_CONTINUE = "".concat(prefix, " show login to continue promt");
export var CLOSE_LOGIN_TO_CONTINUE = "".concat(prefix, " close login to continue promt");
var setApiKey = createAction(SET_API_KEY);
var setLoginError = createAction(HAS_LOGIN_ERROR);
var setSpidKey = createAction(SET_SPID_KEY);
var setBearerToken = createAction(SET_BEARER_TOKEN);
var setLoggedIn = createAction(SET_LOGGED_IN);
var loginToContinue = createAction(SHOW_LOGIN_TO_CONTINUE);
var closeLoginToContinue = createAction(CLOSE_LOGIN_TO_CONTINUE);

var fetchBearerToken = function fetchBearerToken(source) {
  return function (dispatch, getState) {
    var state = getState();
    var body = snakeCaseKeys(state.authentication[source]);
    return axios("".concat(getState().config.urls.api, "/auth/v1/oauth/tokens"), {
      method: 'POST',
      data: querystring.stringify(body),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      // Axios uses proxy by default, if HTTP_PROXY or HTTPS_PROXY is set.
      // Which are set on-prem and that causes issues for internal requests
      proxy: false,
      timeout: API_TIMEOUT
    }).then(handleApiResponse).then(function (bearerToken) {
      dispatch(setBearerToken(bearerToken.accessToken));
      return bearerToken;
    });
  };
};

var deleteBearerToken = function deleteBearerToken() {
  return function (dispatch, getState) {
    var state = getState();
    var bearerToken = state.authentication.bearerToken;
    if (!bearerToken) return Promise.resolve();
    return axios("".concat(getState().config.urls.api, "/auth/v1/oauth/tokens/").concat(bearerToken), {
      method: 'DELETE',
      headers: {
        Authorization: "Bearer ".concat(bearerToken)
      },
      // Axios uses proxy by default, if HTTP_PROXY or HTTPS_PROXY is set.
      // Which are set on-prem and that causes issues for internal requests
      proxy: false,
      timeout: API_TIMEOUT
    }).then(handleApiResponse).then(function () {
      return dispatch(setBearerToken(null));
    });
  };
};

var login = function login(tag) {
  return function (dispatch, getState) {
    if (!isBrowser()) {
      throw new Error('Login should only be done from the browser.');
    }

    var config = getState().config;
    var urlSearch = querystring.stringify({
      client_id: config.spid.clientId,
      response_type: 'code',
      redirect_uri: "".concat(config.urls.beta, "/login/return"),
      cancel_redirect_uri: "".concat(config.urls.beta, "/login/cancel"),
      tag: tag,
      state: ''
    });
    window.location.replace("".concat(config.spid.url, "/flow/login?").concat(urlSearch));
  };
};
/**
 * Opens and closes the login to continue view
 * @param {boolean} showView - show or hide login to continue view
 */


var setLoginToContinue = function setLoginToContinue(loginAlert) {
  return function (dispatch) {
    window.document.body.style.overflow = loginAlert.isOpen ? 'hidden' : 'auto';
    return loginAlert.isOpen ? dispatch(loginToContinue(loginAlert)) : dispatch(closeLoginToContinue(loginAlert));
  };
};
/**
 * Provides a loginUrl to use to login in the user with.
 * @param {*} actionType - popup || samepage
 * @param {string} redirectUrl - the url to redirect the user to when the login process
 * is completed
 * @param {string} cancelUrl - the url to redirect the user to when the user cancels the
 * login process
 */


var getLoginUrl = function getLoginUrl(actionType, redirectUrl, cancelUrl, tag) {
  return function (dispatch, getState) {
    var type = actionType === 'popup' ? 'popup' : 'samepage';
    return "".concat(getState().config.urls.beta, "/login?type=").concat(type, "&redirect=").concat(redirectUrl, "&cancel=").concat(cancelUrl, "&tag=").concat(tag);
  };
};
/**
 * Redirects the user to the login application
 * @param {string} redirectUrl - the url to redirect the user to when the login process
 * is completed
 * @param {string} cancelUrl - the url to redirect the user to when the user cancels the
 * login process
 */


var goToLogin = function goToLogin(redirectUrl, cancelUrl, screenType, tag) {
  return function (dispatch, getState) {
    var loginUrl = dispatch(getLoginUrl(screenType === 'big' ? 'popup' : 'samepage', !_isEmpty(redirectUrl) ? redirectUrl : "".concat(getState().config.urls.beta, "/li"), !_isEmpty(cancelUrl) ? cancelUrl : "".concat(getState().config.urls.beta, "/li"), tag));

    if (screenType === 'big') {
      var wSize = {
        width: 500,
        height: 700
      };
      var wLocation = {
        left: window.screen.availLeft + window.screen.availWidth / 2 - wSize.width / 2,
        top: window.screen.availTop + window.screen.availHeight / 2 - wSize.height / 2
      };
      window.open(loginUrl, '_blank', "location=0,status=0,width=".concat(wSize.width, ",height=").concat(wSize.height, ",left=").concat(wLocation.left, ",top=").concat(wLocation.top));
    } else {
      window.location = loginUrl;
    }
  };
};

var logout = function logout() {
  return function (dispatch, getState) {
    if (!isBrowser()) {
      throw new Error('Logout should only be done from the browser.');
    }

    dispatch(createAction(LOGOUT));
    var config = getState().config;
    var urlSearch = querystring.stringify({
      client_id: config.spid.clientId,
      redirect_uri: "".concat(config.urls.beta)
    });
    var cookies = new Cookies(); // Clean all kinds of different cookies.
    // All of the sites sets diffrent domains of the cookies in different environments

    cookies.remove(AUTH_COOKIE_NAME, {
      path: '/',
      domain: getBaseDomain(getState().config.urls.beta)
    });
    return dispatch(deleteBearerToken()).then(function () {
      window.location = "".concat(config.spid.url, "/logout?").concat(urlSearch);
    });
  };
};

export var actionCreators = {
  fetchBearerToken: fetchBearerToken,
  setBearerToken: setBearerToken,
  setApiKey: setApiKey,
  setSpidKey: setSpidKey,
  setLoggedIn: setLoggedIn,
  logout: logout,
  login: login,
  setLoginError: setLoginError,
  getLoginUrl: getLoginUrl,
  setLoginToContinue: setLoginToContinue,
  goToLogin: goToLogin,
  loginToContinue: loginToContinue,
  closeLoginToContinue: closeLoginToContinue
};
//# sourceMappingURL=actions.js.map